import { apiClient } from '@services/api-client'

import {
  settlementsUrl,
  useSettlementMutation
} from './useSettlementMutation'
import type { SettlementAdvance } from '../types'

/**
 * Rebuilds the advance list from the rent records that actually exist.
 * Manually typed lines are never touched.
 */
export function useImportAdvances() {
  return useSettlementMutation<
    { id: string; replace?: boolean },
    SettlementAdvance[]
  >({
    toastKey: 'settlementAdvancesImported',
    request: async ({ id, replace }) =>
      (
        await apiClient.post<SettlementAdvance[]>(
          `${settlementsUrl}/${id}/advances/import`,
          { replace: replace ?? false }
        )
      ).data
  })
}
